export enum StatusColor {
  Open = '#67daff',
  Closed = '#cfcfcf',
  Solved = '#80e27e',
  Reported = '#f7c560',
  Overdue = '#9a67ea',
  Unassigned = '#ff6090'
}
